// @ts-nocheck
import { put, takeLatest } from 'redux-saga/effects';
import { postAPIDataV3, putAPIDataV3 } from 'utils/api';
import {
	triggeRemoveRowAccess,
	triggerAddAccessLevel,
	triggerAddUserRole,
	triggerCreateUser,
	triggerDeactivateUser,
	triggerRemoveUserRole,
	triggeRemovebulkAccess,
} from './sagaActions';
import { toggleLoader } from 'models/loaders/sagaActions';
import { LOADER_COMPONENTS } from './constants';
import { getDispatch } from 'reducers';
import { triggerFetchAutoComplete } from 'models/autoComplete/sagaActions';
import { triggerNotification } from 'organisms/notifications/sagaActions';
import { Events } from 'molecules/ReactGrid/agGrid/utils/events';
import { GRID_EVENTS } from 'molecules/ReactGrid/agGrid/constants';

export const handleAddAccessLevel = async ({ payload: { selectedEntities, accessLevel, userId } }) => {
	const dispatch = getDispatch();
	try {
		if (!userId) {
			return;
		}
		dispatch(
			toggleLoader({
				componentId: LOADER_COMPONENTS.CREATE_ACCESS,
				isLoading: true,
			})
		);
		const { data } = await postAPIDataV3({
			service: 'acl',
			url: 'accessLevel/user/entity',
			body: {
				selectedEntities,
				accessLevel,
				userId,
			},
		});
		dispatch(
			triggerFetchAutoComplete({
				componentId: 'acl-user-accessLevels',
			})
		);
		dispatch(
			toggleLoader({
				componentId: LOADER_COMPONENTS.CREATE_ACCESS,
				isLoading: false,
			})
		);
	} catch (e) {
		dispatch(
			triggerNotification({
				message: e?.data?.message,
			})
		);
	}
};

export const handleRemoveRowAccess = async ({ payload: { userId, selectedEntities } }) => {
	try {
		const dispatch = getDispatch();

		const { data } = await postAPIDataV3({
			service: 'acl',
			url: 'accessLevel/user/entity/toggle',
			body: {
				IsActive: false,
				selectedEntities,
				userId,
			},
		});
		dispatch(
			triggerFetchAutoComplete({
				componentId: 'acl-user-accessLevels',
			})
		);
	} catch (e) {
		dispatch(
			triggerNotification({
				type: 'error',
				autoClose: 500,
				message: e?.data?.message ?? `Unable to delete Role, Please try again later.`,
			})
		);
	}
};

export const handleRemovebulkAccess = async ({ payload: { tableId, ids } }) => {
	try {
		const { data } = await postAPIDataV3({
			service: 'acl',
			url: `aclGrid/row`,
			body: {
				tableId,
				ids,
				// IsActive: false,
				appId: 'theta-dev-staging',
			},
		});
		Events.publish(GRID_EVENTS.CLEAR_SELECTION, { tableId });
	} catch (e) {
		dispatch(
			triggerNotification({
				type: 'error',
				autoClose: 500,
				message: e?.data?.message ?? `Unable to delete Role, Please try again later.`,
			})
		);
	}
};

export default function* rootSaga() {
	return [
		yield takeLatest(triggerAddAccessLevel, handleAddAccessLevel),
		yield takeLatest(triggeRemoveRowAccess, handleRemoveRowAccess),
		yield takeLatest(triggeRemovebulkAccess, handleRemovebulkAccess),
	];
}
